import React from "react"
import { StaticQuery, graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import styled from "@emotion/styled"
import { rhythm } from "utils/typography"

const dataQuery = graphql`
  query InlineBioQuery {
    avatar: file(absolutePath: { regex: "/denis-isaev-photo.jpg/" }) {
      childImageSharp {
        gatsbyImageData(layout: FIXED, width: 80, height: 80, placeholder: BLURRED, formats: [AUTO, WEBP, AVIF])
      }
    }
    site {
      siteMetadata {
        author {
          name
          summary
        }
      }
    }
  }
`

const InlineBioContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`

const inlineImageWrapperStyle = {
  marginRight: rhythm(1 / 2),
  marginBottom: 0,
  minWidth: `80px`,
}

const inlineImageStyle = {
  marginBottom: 0,
  borderRadius: `50%`,
  maxWidth: `100%`,
  height: `auto`,
}

const InlineBio = () => (
  <StaticQuery
    query={dataQuery}
    render={(data) => (
      <InlineBioContainer>
        <GatsbyImage
          image={getImage(data.avatar)}
          alt={data.site.siteMetadata.author.name}
          style={inlineImageWrapperStyle}
          imgStyle={inlineImageStyle}
        />
        <p style={{ marginBottom: 0 }}>
          Written by <strong>{data.site.siteMetadata.author.name}</strong>
        </p>
      </InlineBioContainer>
    )}
  />
)

export default InlineBio
